module.exports = __webpack_public_path__ + "static/media/logo-greenride.5927df14.png";